export const MODE = import.meta.env.MODE;
export const TARGET = import.meta.env.VITE_TARGET;
export const GOOGLE_PAY_ENV = import.meta.env.VITE_GOOGLE_PAY_ENV;

export const API_ROOT = import.meta.env.VITE_API_ROOT ?? "";

export const ENABLE_DEV_TOOLS = import.meta.env.VITE_ENABLE_DEV_TOOLS;

export const DD_APPID = import.meta.env.VITE_DD_APPID;

export const DD_CLIENTTOKEN = import.meta.env.VITE_DD_CLIENTTOKEN;

export const KOUNT_SESSION_HOSTNAME = import.meta.env
  .VITE_KOUNT_SESSION_HOSTNAME;

export const SPLITIO_AUTHORIZATIONKEY = import.meta.env
  .VITE_SPLITIO_AUTHORIZATIONKEY;
export const UI_ROOT = import.meta.env.VITE_UI_ROOT;

export const VITE_PORT = import.meta.env.VITE_PORT;

export const FIELD_IFRAME_URL = import.meta.env.VITE_FIELD_IFRAME_URL;

// eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
export const COMMIT_HASH = import.meta.env.VITE_COMMIT_HASH;

export const PAZE_SDK = import.meta.env.VITE_PAZE_SDK;

export const DEVICE_FINGERPRINT_SDK = import.meta.env
  .VITE_DEVICE_FINGERPRINT_SDK;
